// extracted by mini-css-extract-plugin
export default {"paddingBottomSm":"padding-module--padding-bottom-sm--ecd70","paddingBottomMd":"padding-module--padding-bottom-md--fda95","paddingMd":"padding-module--padding-md--b425d"};